// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"4391f9b3","345":"0822508a","413":"15e2aef5","427":"61e41127","436":"0bb0d06f","522":"6a007fd3","596":"72b946a7","638":"bcbbb26a","692":"b1571a09","863":"5aa7e66a"}[chunkId] + ".chunk.js";
};